import React, { useState, useEffect } from "react";
import {
  TextField, Button, Box, Typography, Paper, Alert, InputAdornment,
  Snackbar, CircularProgress, useMediaQuery, useTheme, MenuItem, Select, Card, CardContent, Chip
} from "@mui/material";
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined'; // ❌ احذف هذا
import AccountCircle from '@mui/icons-material/AccountCircle';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate } from "react-router-dom";
import { loginUser, fetchAuthRoots, fetchProfileCompletion } from "../services/apiService";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/logo.png"; // ✅ استيراد اللوجو

const Login = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [branches, setBranches] = useState([]);
  const [rootId, setRootId] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [planeData, setPlaneData] = useState(null);
  const [countdown, setCountdown] = useState("");
  const [showExpiryAlert, setShowExpiryAlert] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const { login } = useAuth();

  useEffect(() => {
    const loadBranches = async () => {
      try {
        const data = await fetchAuthRoots();
        console.log("✅ الفروع المستلمة:", data);
        setBranches(data);
      } catch (err) {
        console.error("❌ فشل في تحميل الفروع:", err);
      }
    };

    const loadPlaneData = async () => {
      try {
        const res = await fetchProfileCompletion();
        console.log("✅ رد بيانات الباقة:", res);
        // دعم عدة أشكال للرد: res.data?.plane أو res.plane أو res.data
        const payload = res?.data ?? res;
        setPlaneData(payload);
      } catch (err) {
        console.error("❌ فشل في تحميل بيانات الباقة:", err);
      }
    };
    
    loadBranches();
    loadPlaneData();
  }, []);

  // عرض عد تنازلي قبل انتهاء الباقة (تحديث كل ثانية)
  useEffect(() => {
    const plane = planeData?.plane ?? planeData;
    if (!plane?.end_date) {
      setCountdown("");
      setShowExpiryAlert(false);
      setIsExpired(false);
      return;
    }

    // ننهي اليوم عند نهاية اليوم (23:59:59) لتكون المرئية كاملة في اليوم الأخير
    const endDate = new Date(`${plane.end_date}T23:59:59`);

    let intervalId = null;
    const update = () => {
      const now = new Date();
      const diff = endDate - now;

      if (diff <= 0) {
        setIsExpired(true);
        setShowExpiryAlert(true);
        setCountdown("00 يوم 00:00:00");
        return;
      }

      setIsExpired(false);
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const rem = diff % (1000 * 60 * 60 * 24);
      const hours = Math.floor(rem / (1000 * 60 * 60));
      const minutes = Math.floor((rem % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((rem % (1000 * 60)) / 1000);

      setCountdown(
        `${days} يوم ${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
      );

      // عرض التنبيه إذا تبقى 30 يوم أو أقل
      setShowExpiryAlert(days <= 30);
    };

    update();
    intervalId = setInterval(update, 1000);
    return () => clearInterval(intervalId);
  }, [planeData]);

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleLogin();
  };

  const handleLogin = async () => {
    setLoading(true);

    // ✅ فحص وجود خطة صحيحة
    const plane = planeData?.plane ?? planeData;
    if (!plane || !plane.plane_name || plane.plane_name === "unknown" || plane.plane_name.toLowerCase() === "unknown") {
      setError("⛔ لا يمكنك تسجيل الدخول. لا توجد خطة اشتراك صالحة. الرجاء التواصل مع الدعم الفني لتفعيل الباقة.");
      setLoading(false);
      return;
    }

    // ✅ تمنع التسجيل لو كانت الباقة غير نشطة
    if (plane && Number(plane.is_active) === 0) {
      setError("⛔ لا يمكنك تسجيل الدخول لأن باقتك غير نشطة. الرجاء التجديد أو التواصل مع الدعم.");
      setLoading(false);
      return;
    }

    try {
      const userData = await loginUser(credentials.username, credentials.password, rootId);

      // ✅ نحفظ بيانات المستخدم + التوكن في AuthContext
      login(userData.data, userData.data.token);

      // ✅ باقي البيانات اللي محتاجها
      localStorage.setItem("branch_name", branches.find(branch => branch.id === rootId)?.name || "");
      localStorage.setItem("branch_id", rootId);
      localStorage.setItem("username", userData.data.username);
      localStorage.setItem("user_id", userData.data.id);

      // ✅ تحديد الوجهة حسب نوع المستخدم
      const { type, profile_completation } = userData.data || {};
      let redirect = "/dashboard";

      if (type === "kitchen") redirect = "/TaghezScreen";
      else if (type === "delivery" && profile_completation === 5) redirect = "/Deliverypage";
      else if (type === "SYSTEMBIGADMIN") {
        if (profile_completation === 0) redirect = "/setup/general-info";
        else if (profile_completation === 1) redirect = "/setup/branches";
        else if (profile_completation === 2) redirect = "/setup/tables";
        else if (profile_completation === 3) redirect = "/setup/storages";
        else if (profile_completation === 4) redirect = "/setup/kitchens";
        else if (profile_completation === 5) {
          if (!rootId) {
            setError("برجاء اختيار فرع لعرض البيانات.");
            setLoading(false);
            return;
          }
        }
      } else {
        // أي نوع آخر غير SYSTEMBIGADMIN
        redirect = "/pos";
      }

      setSuccess(true);
      setTimeout(() => navigate(redirect), 1000);

    } catch (err) {
      setError(err.message || "❌ اسم المستخدم أو كلمة المرور غير صحيحة");
    }
    setLoading(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        position: "relative",
        overflow: "hidden",
        px: 2,
      }}
    >
      {/* خلفية متحركة */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "linear-gradient(90deg, #ff9a9e, #fad0c4, #fbc2eb, #ff9a9e)",
          backgroundSize: "400% 400%",
          animation: "gradientAnimation 8s linear infinite",
          filter: "blur(8px)",
          "@keyframes gradientAnimation": {
            "0%": { backgroundPosition: "0% 50%" },
            "100%": { backgroundPosition: "100% 50%" },
          },
        }}
      />

      <Box sx={{ zIndex: 1, width: isSmallScreen ? "100%" : 400 }}>
        {/* تنبيه الانتهاء مع العد التنازلي */}
        {(() => {
          const plane = planeData?.plane ?? planeData;
          if (!plane) return null;

          if (isExpired) {
            return (
              <Alert severity="error" sx={{ mb: 2, fontWeight: "bold" }}>
                ⚠️ انتهت باقتك ({plane.plane_name || "باقة"}) بتاريخ {plane.end_date}. الرجاء التجديد.
              </Alert>
            );
          }

          if (showExpiryAlert) {
            return (
              <Alert severity="warning" sx={{ mb: 2, fontWeight: "bold" }}>
                ⚠️ تنبيه: باقتك ({plane.plane_name || "باقة"}) تنتهي بتاريخ {plane.end_date} — المتبقي: {countdown}
              </Alert>
            );
          }
          return null;
        })()}


        <Paper
          elevation={6}
          sx={{
            p: 4,
            textAlign: "center",
            borderRadius: 3,
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": { transform: "scale(1.02)", boxShadow: 20 },
          }}
        >
          {/* ✅ استبدال الأيقونة باللوجو */}
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              width: 120,
              height: 120,
              mb: 2,
              objectFit: "contain",
              filter: "drop-shadow(0px 4px 10px rgba(0,0,0,0.15))",
            }}
          />
          <Typography variant="h5" sx={{ fontWeight: "bold", mb: 3 }}>
            تسجيل الدخول
          </Typography>

          <TextField
            label="اسم المستخدم"
            name="username"
            fullWidth
            value={credentials.username}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            sx={{ mb: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle color="primary" />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            label="كلمة المرور"
            name="password"
            type="password"
            fullWidth
            value={credentials.password}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            sx={{ mb: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <VpnKeyIcon color="primary" />
                </InputAdornment>
              ),
            }}
          />

          <Select
            fullWidth
            displayEmpty
            value={rootId}
            onChange={(e) => setRootId(e.target.value)}
            sx={{ mb: 2 }}
          >
            <MenuItem value="" disabled>اختر الفرع</MenuItem>
            {branches.map(branch => (
              <MenuItem key={branch.id} value={branch.id}>
                {branch.name}
              </MenuItem>
            ))}
          </Select>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleLogin}
            disabled={loading}
            sx={{ fontSize: isSmallScreen ? "18px" : "20px", py: 1 }}
          >
            {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "تسجيل الدخول"}
          </Button>
        </Paper>
      </Box>

      <Snackbar open={success} autoHideDuration={2000}>
        <Alert severity="success" icon={<CheckCircleOutlineIcon fontSize="inherit" />} sx={{ width: '100%' }}>
          🎉 تمت عملية تسجيل الدخول بنجاح!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Login;
